import popupCtrl from './cian.region-city-browser.ctrl';
import '../styles/cian.region-city-browser.less';

export default [
  () => ({
    scope: {},
    template: `<div button
          text="{$ regionCityBrowser.getTitle() $}"
          ng-click="regionCityBrowser.openPopup()"
          is-popup-open="regionCityBrowser.isPopupOpen" 
          classes="filter__popup-trigger" 
          button-style="{$ regionCityBrowser.isPopupOpen?\'solid\':\'bright\' $}"
        ></div>`,
    restrict: 'EA',
    controllerAs: 'regionCityBrowser',
    controller: [
      '$scope',
      '$uibModal',
      'RegionUtilsService',
      'FilterBackup',
      'FilterService',
      'AnalyticsService',
      function ($scope, $uibModal, RegionUtilsService, FilterBackup, FilterService, AnalyticsService) {
        const ctrl = this;

        const modalClass = 'region-city-browser-modal';

        ctrl.getTitle = function () {
          // Если выбрано несколько, то показываем название группы
          if (FilterService.selectedRegions.length > 1) {
            /** @type {RegionGroup} */
            const regionGroup = RegionUtilsService.findGroup(FilterService.selectedRegions);
            if (regionGroup) return regionGroup.fullName;
          }

          return FilterService.selectedRegions[0].text;
        };

        ctrl.openPopup = () => {
          FilterBackup.backup();
          AnalyticsService.trackCA('Listing', 'popup_GEO_open');

          $uibModal.open({
            animation: true,
            windowClass: `serp-modal ${modalClass}`,
            controller: popupCtrl,
            controllerAs: 'regionCityModal',
            template: require('../../templates/region-city-browser.popup.jade'),
            resolve: {
              modalClass: () => modalClass,
            },
          }).result
            .then(null, FilterBackup.restore)
            .finally(() => {
              ctrl.isPopupOpen = false;
            });
        }
      }]
  })
];



// WEBPACK FOOTER //
// ./src/components/region-city-browser/src/scripts/cian.region-city-browser.dir.js